class Accordion extends HTMLElement {
  constructor() {
    super();

    this.titleEl = this.querySelector("[data-accordion-title]");
    this.body = this.querySelector("[data-accordion-body]");
    if (this.hasAttribute("data-accordion-start-open")) this.open();
    else this.active = false;
  }

  connectedCallback() {
    this.titleEl.addEventListener("click", () => {
      this.handleAccordionClick();
    });
  }

  handleAccordionClick() {
    if (this.active) this.close();
    else this.open();
  }

  open() {
    this.classList.add("open");
    this.body.style.maxHeight = this.body.scrollHeight + 1 + "px";
    this.active = true;
  }

  close() {
    this.classList.remove("open");
    this.body.style.maxHeight = 0;
    this.active = false;
  }
}

customElements.define("accordion-el", Accordion);

class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.selector = this.querySelector("[data-select]");
    this.optionsWrapper = this.querySelector("[data-options]");
    this.options = this.querySelectorAll("[data-option]");
    this.isOpen = false;
    this.valueElement = this.querySelector("[data-selected-value]");
    if (this.options.length > 0)
      this.value = this.valueElement.dataset.selectedValue;
    else this.value = "";
  }

  connectedCallback() {
    this.selector.addEventListener("click", () => {
      this.handleSelectClick();
    });

    this.options.forEach((option) => {
      option.addEventListener("click", () => {
        this.selectValue(option);
      });
    });

    if (this.optionsWrapper) {
      this.optionsWrapper.addEventListener("click", () => {
        this.close();
      });
    }
  }

  handleSelectClick() {
    if (this.isOpen) this.close();
    else this.open();
  }

  open() {
    this.classList.add("open");
    this.isOpen = true;
  }

  close() {
    this.classList.remove("open");
    this.isOpen = false;
  }

  selectValue(option) {
    this.value = option.dataset.value;
    this.valueElement.innerHTML = option.innerHTML;
    this.valueElement.dataset.selectedValue = this.value;
    this.close();

    const event = new CustomEvent("value-changed", {
      detail: {
        newValue: this.value,
      },
    });

    this.dispatchEvent(event);
  }
}

customElements.define("custom-select", CustomSelect);

class VideoWithButton extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.button = this.querySelector("button");
  }

  connectedCallback() {
    if (this.video) {
      this.video.addEventListener("play", () => {
        this.button.style.display = "none";
      });
      this.video.addEventListener("pause", () => {
        this.button.style.display = "flex";
      });

      this.video.addEventListener("ended", () => {
        this.button.style.display = "flex";
      });
    }

    if (this.button) {
      this.button.addEventListener("click", () => {
        this.video.play();
        this.button.style.display = "none";
        this.video.setAttribute("controls", true);
      });
    }
  }
}

customElements.define("video-with-button", VideoWithButton);

class VariantsWithBulk extends HTMLElement {
  constructor() {
    super();

    this.bulkExpander = this.querySelector("[data-bulk-expander]");
    this.bulkOptions = this.querySelector("[data-bulk-options]");
    this.unitOptions = this.querySelectorAll("[data-unit-option]");
    this.deliveryOptions = this.querySelectorAll("[data-delivery-option]");
    this.productPageWrapper = this.closest("product-page");

    this.selectedUnitOption = this.unitOptions[0];
    this.selecteDeliveryOption = this.deliveryOptions[0];
    this.bulkExpanded = false;
  }

  connectedCallback() {
    this.unitOptions.forEach((unitOption) => {
      unitOption.addEventListener("click", () => {
        this.handleOptionSelect(unitOption);
      });
    });

    this.deliveryOptions.forEach((deliveryOption) => {
      deliveryOption.addEventListener("click", () => {
        this.handleDeliveryOptionSelect(deliveryOption);
      });
    });

    if (this.bulkExpander) {
      this.bulkExpander.addEventListener("click", () => {
        this.toggleBulkOptions();
      });
    }
  }

  handleOptionSelect(option) {
    this.selectedUnitOption.classList.add("not-selected");
    option.classList.remove("not-selected");
    this.selectedUnitOption = option;

    const palletRow = this.productPageWrapper.querySelector(
      `[data-bale-row][data-bale-count="${option.dataset.bales}"]`
    );
    // console.log(palletRow);
    palletRow.click();
  }

  handleDeliveryOptionSelect(option) {
    this.selecteDeliveryOption.classList.add("not-selected");
    option.classList.remove("not-selected");
    this.selecteDeliveryOption = option;

    // console.log(option.hasAttribute("data-free-option-selector"));
    if (option.hasAttribute("data-free-option-selector")) {
      // console.log(document.querySelector("[data-free-option]"));
      document.querySelector("[data-free-option]").click();
    } else {
      // console.log(document.querySelector("[data-phs-option]"));
      document.querySelector("[data-phs-option]").click();
    }
  }

  toggleBulkOptions() {
    this.bulkExpanded = !this.bulkExpanded;

    if (this.bulkExpanded) {
      this.bulkOptions.style.maxHeight = "650px";
      this.bulkExpander.querySelector("[data-text]").textContent =
        this.bulkExpander.getAttribute("data-close-text");
      this.bulkExpander.classList.add("expanded");
    } else {
      this.bulkOptions.style.maxHeight = "0";
      this.bulkExpander.querySelector("[data-text]").textContent =
        this.bulkExpander.getAttribute("data-open-text");
      this.bulkExpander.classList.remove("expanded");
    }
  }
}

customElements.define("variants-with-bulk", VariantsWithBulk);

document.addEventListener("DOMContentLoaded", () => {
  const variantOptions = document.querySelectorAll(".vpwb-option");

  variantOptions.forEach((option) => {
    const mostPopularBadge = option.querySelector(".badge.popular");
    if (mostPopularBadge) {
      option.click();
    }
  });

  const variantItems = document.querySelectorAll(
    '.product-variant__item input[type="radio"]'
  );
  // variantItems.forEach(function (radio) {
  //   const radioValue = radio.value;
  //   const variantQty = parseInt(radioValue.split(' ')[0]);
  //   radio.parentElement.classList.remove("selected");

  //   if (variantQty === quantity) {
  //     radio.parentElement.classList.add("selected");
  //   }
  // });
});

document.addEventListener("DOMContentLoaded", function () {
  const reminderKey = "country-reminder-shown";
  const lastClosed = localStorage.getItem(reminderKey);
  const currentDate = new Date();
  const twoMinutes = 2 * 60 * 1000;
  const fiveDays = 5 * 24 * 60 * 60 * 1000;

  if (!lastClosed || currentDate - new Date(lastClosed) > fiveDays) {
    setTimeout(() => {
      showReminder();
    }, 1000);
  }

  function showReminder() {
    const reminder = document.getElementById("country-reminder");
    reminder.classList.add("show");

    setTimeout(() => {
      if (!localStorage.getItem(reminderKey)) {
        closeReminder();
      }
    }, twoMinutes);
  }

  window.closeReminder = function () {
    const reminder = document.getElementById("country-reminder");
    reminder.classList.remove("show");

    localStorage.setItem(reminderKey, new Date().toISOString());
  };

  const countryButtons = document.querySelectorAll(
    "[data-js-localization-form-button]"
  );
  countryButtons.forEach((countryButton) => {
    countryButton.addEventListener("click", function () {
      localStorage.setItem(reminderKey, new Date().toISOString());
      closeReminder();
    });
  });
});

class VariantsWithBulkForApp extends HTMLElement {
  constructor() {
    super();

    this.bulkExpander = this.querySelector("[data-bulk-expander]");
    this.bulkOptions = this.querySelector("[data-bulk-options]");
    this.unitOptions = this.querySelectorAll("[data-unit-option]");
    this.productPageWrapper = this.closest("product-page");

    this.selectedUnitOption = this.unitOptions[0];
    this.bulkExpanded = false;

    this.totalPriceEl = document.querySelector("[data-product-total-price]");
    this.totalPriceElDouble = document.querySelector("[data-product-total-price-double]");
    this.totalPriceElSticky = document.querySelector("[data-product-total-price-sticky]");
    // console.log(this.totalPriceEl);
    this.pricePerBaleEl = document.querySelector(
      "[data-product-price-per-bale-big]"
    );
    // console.log(this.pricePerBaleEl);
    this.totalPriceMobileEl = document.querySelector(
      '[data-update-block="product-total-price-mobile"]'
    );
  }

  connectedCallback() {
    this.unitOptions.forEach((unitOption) => {
      unitOption.addEventListener("click", () => {
        this.handleOptionSelect(unitOption);
      });
    });

    if (this.bulkExpander) {
      this.bulkExpander.addEventListener("click", () => {
        this.toggleBulkOptions();
      });
    }

    let intervalCount = 0;
    const intervalRetries = 20;
    const appCheckerIntervalId = setInterval(() => {
      const appContainer = document.querySelector(".otTableOffer");
      if (!appContainer) return false;

      const appTable = appContainer.querySelector("table");
      if (!appTable) return false;

      intervalCount++;
      this.isAppLoaded();

      if (intervalCount > intervalRetries || appTable)
        clearInterval(appCheckerIntervalId);
    }, 200);

    if (this.hasAttribute("data-only-bulk")) {
      this.setupOnlyBulk();
    }

    const variantDataEl = document.querySelector("[data-js-variant-data]");
    if (variantDataEl) {
      new MutationObserver(() => {
        this.updateOptionsOnVariantChange();
      }).observe(variantDataEl, { attributes: false, childList: true, subtree: false });
    }
  }

  updateOptionsOnVariantChange() {
    const variantDataEl = document.querySelector("[data-js-variant-data]");
    if (!variantDataEl) return;

    let variantData;
    try {
      variantData = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variantData || !variantData.price) return;

    const priceInCents = variantData.price;
    const priceFormatted = `€${this.formatEuro(priceInCents / 100)}`;

    this.querySelectorAll(".vpwb-option").forEach((option) => {
      const qty = parseInt(option.dataset.bales, 10);
      const totalFormatted = `€${this.formatEuro((priceInCents * qty) / 100)}`;

      option.dataset.pricePerBale = priceFormatted;

      const pricePerBaleEl = option.querySelector("[data-vo-price-per-bale]");
      if (pricePerBaleEl) pricePerBaleEl.innerHTML = priceFormatted;

      const totalEl = option.querySelector("[data-vo-total-price]");
      if (totalEl) totalEl.innerHTML = totalFormatted;
    });

    if (this.selectedUnitOption) this.updatePrice(this.selectedUnitOption);
  }

  setupOnlyBulk() {
    const options = this.querySelectorAll(".vpwb-option");
    const qtyWrapper = document.querySelector("[data-js-product-quantity]");
    if (!qtyWrapper) return;
    const qtyInput = qtyWrapper.querySelector("input");
    if (!qtyInput) return;

    options.forEach(function (option) {
      const optionQuantity = option.dataset.bales;

      option.addEventListener("click", () => {
        qtyWrapper.style.opacity = "0.5";
      });
    });

    qtyWrapper.addEventListener("click", () => {
      qtyWrapper.style.opacity = "1";

      options.forEach(function (option) {
        option.classList.add("not-selected");
      });
    });
  }

  handleOptionSelect(option) {
    this.selectedUnitOption.classList.add("not-selected");
    option.classList.remove("not-selected");
    this.selectedUnitOption = option;

    const palletRow = this.productPageWrapper.querySelector(
      `[data-bale-row][data-bale-count="${option.dataset.bales}"]`
    );
    // console.log(palletRow);
    // palletRow.click();
    this.updatePrice(option);
    if (!this.hasAttribute("data-only-bulk")) {
      this.updateQuantity(option);
    }
  }

  updatePrice(option) {
    this.totalPriceEl = document.querySelector("[data-product-total-price]");
    this.totalPriceElDouble = document.querySelector("[data-product-total-price-double]");
    this.totalPriceElSticky = document.querySelector("[data-product-total-price-sticky]");
    // console.log(this.totalPriceEl);
    this.pricePerBaleEl = document.querySelector(
      "[data-product-price-per-bale-big]"
    );
    this.pricePerBaleElSticky = document.querySelector(
      "[data-product-price-per-bale-big-sticky]"
    );
    this.pricePerBaleElBaleOnly = document.querySelector(
      "[data-product-price-per-bale-big-bale]"
    );
    // console.log(this.pricePerBaleEl);
    this.totalPriceMobileEl = document.querySelector(
      '[data-update-block="product-total-price-mobile"]'
    );

    const totalPrice = option.querySelector("[data-vo-total-price]");
    const pricePerBale = option.querySelector(".price-per-bale");

    if (this.totalPriceEl) {
      this.totalPriceEl.innerHTML = totalPrice.innerHTML;
      this.pricePerBaleEl.innerHTML = option.dataset.pricePerBale;
    }

    if(this.pricePerBaleElSticky) {
      this.pricePerBaleElSticky.innerHTML = option.dataset.pricePerBale;
    }
    if(this.pricePerBaleElBaleOnly) {
      this.pricePerBaleElBaleOnly.innerHTML = option.dataset.pricePerBale;
    }
    if(this.totalPriceElDouble) {
      this.totalPriceElDouble.innerHTML = totalPrice.innerHTML;
    }
    if(this.totalPriceElSticky) {
      this.totalPriceElSticky.innerHTML = totalPrice.innerHTML;
    }

    if (this.totalPriceMobileEl) {
      this.totalPriceMobileEl.querySelector("[data-price-only]").innerHTML =
        option.dataset.pricePerBale;
    }
  }

  updateQuantity(option) {
    const quantity = document.querySelector(".product-quantity__selector");

    quantity.value = option.dataset.bales;
  }

  isAppLoaded() {
    const appContainer = document.querySelector(".otTableOffer");
    if (!appContainer) return false;

    const appTable = appContainer.querySelector("table");
    if (!appTable) return false;

    const rows = [...appTable.querySelectorAll("tr")].slice(1);
    if (!rows.length) return false;

    const appData = rows.map((row) => {
      const cells = row.querySelectorAll("td");

      const quantity = parseInt(cells[0].innerText.trim(), 10);
      const discount = cells[1].innerText.trim();
      const pricePerProduct = cells[2].innerText.trim();
      const totalAmount = cells[3].innerText.trim();

      const numericPP = parseFloat(
        pricePerProduct.replace(/[^\d,]/g, "").replace(",", ".")
      );
      const numericTotal = parseFloat(
        totalAmount.replace(/[^\d,]/g, "").replace(",", ".")
      );

      return {
        quantity,
        discount,
        pricePerProduct,
        totalAmount,
        numericPP,
        numericTotal,
      };
    });

    const options = this.querySelectorAll(".vpwb-option");

    options.forEach((option) => {
      const qty = parseInt(option.dataset.bales, 10);
      let match = null;
      appData.forEach((priceBreak) => {
        if (qty >= priceBreak.quantity) {
          match = priceBreak;
        }
      });
      if (!match) return;
      const totalPrice = match.numericPP * qty;
      const discountPercent = parseFloat(match.discount.replace("%", "")) / 100;
      const comparePP = this.dataset.defaultPrice;
      const compareTotal = comparePP * qty;

      option.dataset.pricePerBale = match.pricePerProduct;
      option.querySelector("[data-vo-price-per-bale]").innerHTML =
        match.pricePerProduct;

      const compareEl = option.querySelector("[data-vo-compare-price]");
      const valueBadge = option.querySelector(".badge.value");
      if (compareEl) {
        compareEl.innerHTML = `€${this.formatEuro(compareTotal)}`;
        if (compareTotal > totalPrice) {
          compareEl.classList.remove("force-hide");
          if(valueBadge) valueBadge.classList.remove("force-hide");
        }
        else {
          compareEl.classList.add("force-hide");
          if(valueBadge) valueBadge.classList.add("force-hide");
        }
      }

      const totalEl = option.querySelector("[data-vo-total-price]");
      if (totalEl) totalEl.innerHTML = `€${this.formatEuro(totalPrice)}`;

      const savingsEl = option.querySelector("[data-vo-savings]");
      if (savingsEl) {
        if (match.discount !== "0%" && match.discount !== "0") {
          savingsEl.innerHTML = `Save ${match.discount}`;
          savingsEl.classList.remove("hidden");
        } else {
          savingsEl.classList.add("hidden");
        }
      }
    });

    // console.log("BOTTOM")
    // console.log(this.unitOptions[1])
    this.updatePrice(this.unitOptions[1]);
  }

  formatEuro(num) {
    return num
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  handleDeliveryOptionSelect(option) {
    this.selecteDeliveryOption.classList.add("not-selected");
    option.classList.remove("not-selected");
    this.selecteDeliveryOption = option;

    // console.log(option.hasAttribute("data-free-option-selector"));
    if (option.hasAttribute("data-free-option-selector")) {
      // console.log(document.querySelector("[data-free-option]"));
      document.querySelector("[data-free-option]").click();
    } else {
      // console.log(document.querySelector("[data-phs-option]"));
      document.querySelector("[data-phs-option]").click();
    }
  }

  toggleBulkOptions() {
    this.bulkExpanded = !this.bulkExpanded;

    if (this.bulkExpanded) {
      this.bulkOptions.style.maxHeight = "650px";
      this.bulkExpander.querySelector("[data-text]").textContent =
        this.bulkExpander.getAttribute("data-close-text");
      this.bulkExpander.classList.add("expanded");
    } else {
      this.bulkOptions.style.maxHeight = "0";
      this.bulkExpander.querySelector("[data-text]").textContent =
        this.bulkExpander.getAttribute("data-open-text");
      this.bulkExpander.classList.remove("expanded");
    }
  }
}

customElements.define("variants-with-bulk-for-app", VariantsWithBulkForApp);

function termsLogic() {
  const STORAGE_KEY = "cart_terms_accepted";
  
  const termsOpener = document.getElementById("termsOpener");
  let termsCheckbox = document.getElementById("CartTerms");
  const cartTerms = document.getElementById("CartTermsWrapper");
  const checkoutButton = document.getElementById("CheckOut");
  const termsButton = document.getElementById("termsPopupButton");
  const closeBtn = document.getElementById("termsPopupClose");
  const termsPopup = document.getElementById("termsPopup");

  checkoutButton.classList.add("terms-disabled");
  termsCheckbox.checked = false;

  const storedValue = localStorage.getItem(STORAGE_KEY) === "true";
  termsCheckbox.checked = storedValue;

  if (storedValue) {
    checkoutButton.classList.remove("terms-disabled");
  } else {
    checkoutButton.classList.add("terms-disabled");
  }

  if (termsOpener) {
    termsOpener.addEventListener("click", (e) => {
      e.preventDefault();
      termsPopup.classList.add("show");
    });
  }

  if (!checkoutButton || !termsCheckbox) return;

  checkoutButton.addEventListener("click", (e) => {
    termsCheckbox = document.getElementById("CartTerms");
    if (!termsCheckbox.checked) {
      e.preventDefault();
      e.stopPropagation();

      cartTerms.classList.add("warning");
      cartTerms.classList.add("warning-shake");

      setTimeout(() => {
        cartTerms.classList.remove("warning-shake");
      }, 400);
    }
  });

  termsCheckbox.addEventListener("change", () => {
    localStorage.setItem(STORAGE_KEY, termsCheckbox.checked);

    if (termsCheckbox.checked) {
      cartTerms.classList.remove("warning-shake", "warning");
      checkoutButton.classList.remove("terms-disabled");
    } else {
      checkoutButton.classList.add("terms-disabled");
    }
  });

  if (termsButton) {
    termsButton.addEventListener("click", () => {
      termsCheckbox.checked = true;
      localStorage.setItem(STORAGE_KEY, "true");
      
      termsPopup.classList.remove("show");
      checkoutButton.classList.remove("terms-disabled");
    });
  }

  closeBtn?.addEventListener("click", () => {
    termsPopup.classList.remove("show");
  });

  termsPopup.addEventListener("click", (e) => {
    if (e.target === termsPopup) {
      termsPopup.classList.remove("show");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && termsPopup.classList.contains("show")) {
      termsPopup.classList.remove("show");
    }
  });
}

function limitLogic() {
  const limitEl = document.querySelector("[data-cart-limit]");
  const cartInfo = document.querySelector("[data-cart-information]");
  const cartData = JSON.parse(cartInfo.textContent);
  const checkoutButton = document.getElementById("CheckOut");
  if(!limitEl) return;
  const limitString = limitEl.dataset.cartLimit;
  if(!limitString) return;

  const limit = Number(limitString);
  const cartTotal = Number(cartData.cart.total);

  if (cartTotal >= limit) {
    checkoutButton.classList.remove("limit-disabled");
  } else {
    checkoutButton.classList.add("limit-disabled");
  }

  checkoutButton.addEventListener("click", (e) => {  
    const cartInfo = document.querySelector("[data-cart-information]");
    const cartData = JSON.parse(cartInfo.textContent);
    const cartTotal = Number(cartData.cart.total);

    if (cartTotal < limit) {
      e.preventDefault();
      e.stopPropagation();

      limitEl.classList.add("warning");
      limitEl.classList.add("warning-shake");

      setTimeout(() => {
        limitEl.classList.remove("warning-shake");
      }, 400);
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  termsLogic();
  limitLogic();
});

document.addEventListener("cart-updated-global", () => {
  termsLogic();
  limitLogic();
});

document.addEventListener("item-added-global", () => {
  termsLogic();
  limitLogic();
});
